export var SearchResponseDeviceType;
(function (SearchResponseDeviceType) {
    SearchResponseDeviceType["DESKTOP"] = "pc";
    SearchResponseDeviceType["MOBILE"] = "mobile";
    SearchResponseDeviceType["TABLET"] = "tablet";
})(SearchResponseDeviceType || (SearchResponseDeviceType = {}));
export var SearchResponseSectionType;
(function (SearchResponseSectionType) {
    SearchResponseSectionType["JS"] = "js";
    SearchResponseSectionType["HTML"] = "html";
    SearchResponseSectionType["CSS"] = "css";
})(SearchResponseSectionType || (SearchResponseSectionType = {}));
export var SearchResponseWidgetUsedIn;
(function (SearchResponseWidgetUsedIn) {
    SearchResponseWidgetUsedIn["PAGE"] = "page";
    SearchResponseWidgetUsedIn["COMMON_ACROSS_PAGES"] = "common_across_pages";
    SearchResponseWidgetUsedIn["DIALOG"] = "dialog";
})(SearchResponseWidgetUsedIn || (SearchResponseWidgetUsedIn = {}));
